
import { images } from ".";

const tours = [
    {
        id: 1,
        image: images.tour1,
        title: "Barcelona Escape",
        content: "Discover the city of Barcelona, where art, architecture, and Mediterranean charm come together in a journey.",
        details: {
            location: "Spain",
            tourType: "City Exploration",
            checkIn: "April 10, 2025",
            checkOut: "April 14, 2025",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Boutique City Hotels",
            transportation: "Included",
            bestSeason: "Spring and Autumn",
            activity: "Sightseeing"
        },
        overviews: [
            "Explore Barcelona’s iconic landmarks, from the intricate works of Gaudí to the lively Las Ramblas. Enjoy a perfect blend of culture, history, and seaside relaxation in this Mediterranean gem."
        ],
        highlights: [
            "Guided Tour of Sagrada Família",
            "Stroll through Park Güell",
            "Walk down La Rambla and Gothic Quarter",
            "Sunset at Barceloneta Beach",
            "Visit to Picasso Museum"
        ],
        included: [
            "Professional City Guide",
            "Entrance Tickets to Main Attractions",
            "3-Night Hotel Accommodation",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Tapas Tour",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & La Rambla Walk",
                description: "Arrive in Barcelona and settle into your hotel. In the evening, take a guided walk through the bustling La Rambla and explore the Gothic Quarter.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Walk on La Rambla",
                    "Gothic Quarter Guided Exploration"
                ]
            },
            {
                day: "Day 2: Gaudí’s Masterpieces",
                description: "Visit Sagrada Família and Park Güell to admire Gaudí’s unique architecture. Afternoon leisure time for personal exploration or shopping.",
                activities: [
                    "Morning Visit to Sagrada Família",
                    "Guided Tour of Park Güell",
                    "Afternoon Leisure or Optional Shopping Tour"
                ]
            },
            {
                day: "Day 3: Beachside Relaxation & Cultural Sights",
                description: "Enjoy a morning visit to the Picasso Museum followed by leisure time at Barceloneta Beach to unwind and enjoy the Mediterranean vibes.",
                activities: [
                    "Morning Visit to Picasso Museum",
                    "Leisure Time at Barceloneta Beach",
                    "Optional Tapas Dinner Tour"
                ]
            },
            {
                day: "Day 4: Departure",
                description: "Spend the morning shopping for souvenirs or taking a final stroll before your airport transfer.",
                activities: [
                    "Leisure Morning Walk",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Barcelona blends architectural splendor, cultural vibrancy, and seaside charm, making it one of Europe’s must-visit cities. This tour provides a curated experience of its top attractions and hidden gems.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2992.037163432244!2d2.173403515423122!3d41.385063979263004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4a2f17b7bdc05%3A0x3e5d7e6a4a61e8f9!2sBarcelona!5e0!3m2!1sen!2ses!4v1715802467890!5m2!1sen!2ses"
        },
        gallery: [
            images.tour1Gallery1,
            images.tour1Gallery2,
            images.tour1Gallery3,
            images.tour1Gallery4,
            images.tour1Gallery5,
            images.tour1Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour1Review1,
                name: "Emma Roberts",
                date: "April 15, 2025",
                rating: 5,
                content: "Absolutely loved this tour! The Gaudí architecture was breathtaking and everything was perfectly organized."
            },
            {
                id: 2,
                image: images.tour1Review2,
                name: "Daniel Smith",
                date: "April 16, 2025",
                rating: 4.8,
                content: "Great blend of culture, sightseeing, and beach time. Highly recommend for first-time Barcelona visitors."
            }
        ]
    },
    {
        id: 2,
        image: images.tour2,
        title: "Madrid Getaway",
        content: "Dive into the heart of Spain with a journey through Madrid’s iconic landmarks, palaces, and lively plazas.",
        details: {
            location: "Spain",
            tourType: "City Exploration",
            checkIn: "April 15, 2025",
            checkOut: "April 18, 2025",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Central City Hotels",
            transportation: "Included",
            bestSeason: "Spring and Fall",
            activity: "Sightseeing"
        },
        overviews: [
            "Experience Madrid’s royal heritage, world-class art museums, and bustling city life. This short yet comprehensive tour is perfect for those wanting to capture the essence of Spain’s capital."
        ],
        highlights: [
            "Visit to Royal Palace of Madrid",
            "Tour of Prado Museum",
            "Walk through Plaza Mayor",
            "Retiro Park Boating Experience",
            "Gran Vía Shopping Walk"
        ],
        included: [
            "Professional City Guide",
            "Entry Tickets to Major Attractions",
            "2-Night Hotel Accommodation",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Flamenco Night Show",
            "Personal Shopping",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & City Stroll",
                description: "Arrive in Madrid and settle into your hotel. Evening guided stroll through Plaza Mayor and nearby tapas bars.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Walk at Plaza Mayor",
                    "Optional Tapas Bar Tour"
                ]
            },
            {
                day: "Day 2: Royal & Art Treasures",
                description: "Morning visit to the Royal Palace, followed by an afternoon exploration of the Prado Museum and Retiro Park.",
                activities: [
                    "Guided Tour of Royal Palace of Madrid",
                    "Prado Museum Visit",
                    "Retiro Park Boat Ride",
                    "Evening Leisure Time at Gran Vía"
                ]
            },
            {
                day: "Day 3: Departure",
                description: "Enjoy a leisure morning for shopping or personal exploration before departure.",
                activities: [
                    "Leisure Morning",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Madrid blends its royal past with vibrant modern culture. From historical palaces to artistic masterpieces, this tour encapsulates the city’s timeless allure.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.8406508740563!2d-3.703790484679847!3d40.41677537936373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4228872828d4d5%3A0x64ddc6c0efde41c1!2sMadrid!5e0!3m2!1sen!2ses!4v1715802467890!5m2!1sen!2ses"
        },
        gallery: [
            images.tour2Gallery1,
            images.tour2Gallery2,
            images.tour2Gallery3,
            images.tour2Gallery4,
            images.tour2Gallery5,
            images.tour2Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour2Review1,
                name: "Sophia Martinez",
                date: "April 19, 2025",
                rating: 5,
                content: "Madrid’s energy is contagious! The Royal Palace was stunning, and I loved the art-filled day at the Prado."
            },
            {
                id: 2,
                image: images.tour2Review2,
                name: "James Allen",
                date: "April 20, 2025",
                rating: 4.7,
                content: "A perfect getaway! Everything was smooth, and the guide was very knowledgeable."
            }
        ]
    },
    {
        id: 3,
        image: images.tour3,
        title: "Seville Discovery",
        content: "Experience Andalusia's capital with its history, flamenco, and architectural wonders on this city tour.",
        details: {
            location: "Spain",
            tourType: "Cultural Heritage",
            checkIn: "July 5, 2025",
            checkOut: "July 10, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Boutique City Hotels",
            transportation: "Included",
            bestSeason: "Spring and Fall",
            activity: "Sightseeing"
        },
        overviews: [
            "Delve into Seville’s Moorish architecture, vibrant flamenco culture, and sun-drenched plazas. This guided tour offers a perfect blend of history, art, and Andalusian lifestyle, designed for travelers seeking an authentic Spanish experience."
        ],
        highlights: [
            "Visit to Seville Cathedral & Giralda Tower",
            "Tour of Real Alcázar Palace",
            "Walk through Barrio Santa Cruz",
            "Evening Flamenco Show",
            "Cruise on the Guadalquivir River"
        ],
        included: [
            "Professional Local Guide",
            "Entrance Fees to Major Attractions",
            "4-Night Hotel Accommodation",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Tapas Tour",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Evening Walk",
                description: "Arrive in Seville and settle into your hotel. Enjoy a relaxing evening walk through Barrio Santa Cruz and a welcome briefing.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Walk through Barrio Santa Cruz",
                    "Welcome Briefing with Guide"
                ]
            },
            {
                day: "Day 2: Cathedral & Alcázar",
                description: "Explore the Seville Cathedral and Giralda Tower, followed by a guided tour of the Real Alcázar Palace.",
                activities: [
                    "Morning Visit to Seville Cathedral & Giralda",
                    "Guided Tour of Real Alcázar",
                    "Afternoon Leisure Time",
                    "Optional Evening Tapas Tour"
                ]
            },
            {
                day: "Day 3: Flamenco & Cultural Sites",
                description: "Dive into Seville’s culture with visits to Plaza de España, Metropol Parasol, and enjoy an authentic flamenco show in the evening.",
                activities: [
                    "Visit Plaza de España & Maria Luisa Park",
                    "Walk to Metropol Parasol (Las Setas)",
                    "Evening Flamenco Show Experience"
                ]
            },
            {
                day: "Day 4: River Cruise & Local Markets",
                description: "Enjoy a relaxing cruise on the Guadalquivir River and explore local artisan markets in Triana.",
                activities: [
                    "Morning River Cruise",
                    "Visit to Triana Neighborhood",
                    "Explore Artisan Markets",
                    "Farewell Dinner (optional)"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Free time for last-minute shopping or leisure walks before departure.",
                activities: [
                    "Leisure Morning",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Seville’s cobblestone streets, stunning palaces, and lively cultural scene create an enchanting atmosphere that captivates every visitor. This tour immerses you in the heart of Andalusian traditions and history.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.42576391647!2d-5.99407218494166!3d37.388630979832955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd126c110cc6b76f%3A0x8ef99b8d0f6d6796!2sSeville%2C%20Spain!5e0!3m2!1sen!2ses!4v1715802467890!5m2!1sen!2ses"
        },
        gallery: [
            images.tour3Gallery1,
            images.tour3Gallery2,
            images.tour3Gallery3,
            images.tour3Gallery4,
            images.tour3Gallery5,
            images.tour3Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour3Review1,
                name: "Laura Fernandez",
                date: "July 10, 2025",
                rating: 5,
                content: "An incredible journey through Seville’s rich culture and history. The flamenco night was unforgettable!"
            },
            {
                id: 2,
                image: images.tour3Review2,
                name: "David Wilson",
                date: "July 11, 2025",
                rating: 4.9,
                content: "Perfectly organized tour! Loved the cathedral tour and the tapas in Triana. Highly recommend."
            }
        ]
    },
    {
        id: 4,
        image: images.tour4,
        title: "Dubai Highlights",
        content: "Discover the sights and wonders of Dubai, blending modern luxury with Arabian heritage on this city tour.",
        details: {
            location: "United Arab Emirates",
            tourType: "City Exploration",
            checkIn: "August 1, 2025",
            checkOut: "August 5, 2025",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Luxury Hotels",
            transportation: "Included",
            bestSeason: "Winter and Spring",
            activity: "Desert Safari"
        },
        overviews: [
            "From towering skyscrapers to golden desert dunes, Dubai offers a dynamic mix of luxury, adventure, and tradition. This tour is crafted for travelers eager to experience Dubai's top landmarks and hidden gems."
        ],
        highlights: [
            "Visit to Burj Khalifa Observation Deck",
            "Evening Desert Safari with BBQ Dinner",
            "Explore Dubai Marina and JBR Walk",
            "Cultural Visit to Al Fahidi Historical District",
            "Shopping Experience at Dubai Mall"
        ],
        included: [
            "Professional City Guide",
            "Burj Khalifa Entry Tickets",
            "Desert Safari Experience",
            "3-Night Hotel Accommodation",
            "Daily Breakfast & Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner (except Safari BBQ)",
            "Personal Shopping",
            "Optional Yacht Tour",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Downtown Tour",
                description: "Arrive in Dubai and check-in to your hotel. Enjoy an evening city tour of Downtown Dubai including Dubai Fountain and Souk Al Bahar.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Walk to Dubai Fountain Show",
                    "Explore Souk Al Bahar"
                ]
            },
            {
                day: "Day 2: Iconic Landmarks",
                description: "Visit the Burj Khalifa, Dubai Mall, and Palm Jumeirah. Afternoon leisure or optional yacht cruise.",
                activities: [
                    "Morning Visit to Burj Khalifa Observation Deck",
                    "Dubai Mall Aquarium & Underwater Zoo",
                    "Drive to Palm Jumeirah & Atlantis",
                    "Optional Yacht Tour from Marina"
                ]
            },
            {
                day: "Day 3: Desert Adventure",
                description: "Embark on a thrilling desert safari with dune bashing, camel rides, and a traditional Bedouin-style BBQ dinner under the stars.",
                activities: [
                    "Afternoon Desert Safari",
                    "Dune Bashing & Camel Riding",
                    "BBQ Dinner with Live Entertainment"
                ]
            },
            {
                day: "Day 4: Cultural & Souk Visit",
                description: "Explore Old Dubai with visits to Al Fahidi District, Dubai Creek, and traditional souks before departure.",
                activities: [
                    "Guided Tour of Al Fahidi Historical District",
                    "Abra Ride across Dubai Creek",
                    "Visit to Gold & Spice Souks",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Dubai seamlessly blends futuristic architecture with timeless cultural heritage. From luxury shopping to desert adventures, this tour provides a comprehensive experience of Dubai’s must-see attractions.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115683.86290715293!2d55.17127930788574!3d25.197201962077465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f434fe85ed1d7%3A0x58c86b8e8e92a64c!2sDubai!5e0!3m2!1sen!2sae!4v1715802467890!5m2!1sen!2sae"
        },
        gallery: [
            images.tour4Gallery1,
            images.tour4Gallery2,
            images.tour4Gallery3,
            images.tour4Gallery4,
            images.tour4Gallery5,
            images.tour4Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour4Review1,
                name: "Amelia Clarke",
                date: "August 6, 2025",
                rating: 5,
                content: "This tour was everything I imagined Dubai to be—luxurious, thrilling, and rich in culture. The desert safari was a highlight!"
            },
            {
                id: 2,
                image: images.tour4Review2,
                name: "Liam Peterson",
                date: "August 7, 2025",
                rating: 4.8,
                content: "Loved the Burj Khalifa and the Marina. Everything was so well organized. Will definitely recommend this tour to friends."
            }
        ]
    },
    {
        id: 5,
        image: images.tour5,
        title: "Abu Dhabi",
        content: "Experience the splendor of Abu Dhabi, from grand mosques to attractions on this city tour.",
        details: {
            location: "United Arab Emirates",
            tourType: "Cultural Heritage",
            checkIn: "September 10, 2025",
            checkOut: "September 13, 2025",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Luxury City Hotels",
            transportation: "Included",
            bestSeason: "Winter and Spring",
            activity: "Cultural Exploration, Desert Safari"
        },
        overviews: [
            "Abu Dhabi offers a unique blend of Arabian heritage and modern attractions. This tour covers its iconic landmarks, rich traditions, and luxurious experiences designed for travelers seeking a refined cultural getaway."
        ],
        highlights: [
            "Visit to Sheikh Zayed Grand Mosque",
            "Explore Louvre Abu Dhabi Museum",
            "Tour of Qasr Al Watan Palace",
            "Walk through Corniche Beachfront",
            "Optional Ferrari World Visit"
        ],
        included: [
            "Professional Local Guide",
            "Entry Fees to Major Attractions",
            "2-Night Hotel Accommodation",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Ferrari World Tickets",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Cultural Exploration",
                description: "Arrive in Abu Dhabi and visit the Sheikh Zayed Grand Mosque, followed by an evening stroll along the Corniche waterfront.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Guided Tour of Sheikh Zayed Grand Mosque",
                    "Evening Corniche Walk",
                    "Welcome Briefing"
                ]
            },
            {
                day: "Day 2: Museums & Heritage Sites",
                description: "Explore the Louvre Abu Dhabi, Qasr Al Watan Presidential Palace, and enjoy leisure time for shopping or optional Ferrari World visit.",
                activities: [
                    "Morning Visit to Louvre Abu Dhabi",
                    "Guided Tour of Qasr Al Watan Palace",
                    "Afternoon Leisure at Marina Mall",
                    "Optional Visit to Ferrari World"
                ]
            },
            {
                day: "Day 3: Departure",
                description: "Leisure morning for personal exploration before departure.",
                activities: [
                    "Leisure Morning Walks",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Abu Dhabi, the UAE’s capital, dazzles with its grand architecture, artistic landmarks, and serene coastline. This tour immerses you in the Emirati culture while offering luxurious experiences.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29051.451112356256!2d54.331277!3d24.4538846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e676c8f8b0cf3%3A0x8be8b2fda92bcb17!2sAbu%20Dhabi!5e0!3m2!1sen!2sae!4v1715802467890!5m2!1sen!2sae"
        },
        gallery: [
            images.tour5Gallery1,
            images.tour5Gallery2,
            images.tour5Gallery3,
            images.tour5Gallery4,
            images.tour5Gallery5,
            images.tour5Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour5Review1,
                name: "Isabella White",
                date: "September 14, 2025",
                rating: 5,
                content: "The Grand Mosque and Louvre were stunning. A luxurious, well-paced tour that made Abu Dhabi unforgettable."
            },
            {
                id: 2,
                image: images.tour5Review2,
                name: "Daniel Green",
                date: "September 15, 2025",
                rating: 4.8,
                content: "Loved the mix of culture and modern attractions. Ferrari World was a thrilling addition!"
            }
        ]
    },
    {
        id: 6,
        image: images.tour6,
        title: "Sharjah Culture",
        content: "Dive into the heart of the UAE’s capital, exploring Sharjah’s heritage, art scene, and preserved historical sites.",
        details: {
            location: "United Arab Emirates",
            tourType: "Cultural Heritage",
            checkIn: "October 5, 2025",
            checkOut: "October 10, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Traditional Boutique Hotels",
            transportation: "Included",
            bestSeason: "Winter and Spring",
            activity: "Cultural Exploration, Desert Safari"
        },
        overviews: [
            "Sharjah, known as the cultural heart of the UAE, offers a treasure trove of museums, art galleries, and restored heritage sites. This tour is perfect for history enthusiasts and culture seekers."
        ],
        highlights: [
            "Visit to Sharjah Museum of Islamic Civilization",
            "Guided Walk through Al Noor Island",
            "Exploration of Heart of Sharjah Heritage Area",
            "Stroll at Al Qasba Waterfront",
            "Traditional Souk Al Arsah Shopping Experience"
        ],
        included: [
            "Professional Cultural Guide",
            "Entry Fees to Museums & Attractions",
            "4-Night Boutique Hotel Accommodation",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Art Workshops",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Heritage Walk",
                description: "Arrive in Sharjah, settle into your hotel, and take an evening walk through the Heart of Sharjah Heritage Area.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Heritage Walk",
                    "Welcome Orientation"
                ]
            },
            {
                day: "Day 2: Museums & Art Galleries",
                description: "Visit Sharjah Museum of Islamic Civilization and Sharjah Art Museum, followed by an afternoon at Al Noor Island.",
                activities: [
                    "Morning Museum Visits",
                    "Guided Tour of Sharjah Art Museum",
                    "Walk through Al Noor Island Garden"
                ]
            },
            {
                day: "Day 3: Waterfront & Markets",
                description: "Stroll through Al Qasba waterfront, visit traditional markets, and enjoy an optional evening dhow cruise.",
                activities: [
                    "Al Qasba Canal Walk",
                    "Visit Souk Al Arsah",
                    "Optional Evening Dhow Cruise"
                ]
            },
            {
                day: "Day 4: Leisure & Workshops",
                description: "Enjoy leisure time for personal exploration or participate in optional cultural workshops like calligraphy or pottery.",
                activities: [
                    "Leisure Day or Optional Art Workshops",
                    "Evening at Leisure"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Morning free for last-minute shopping or visiting local cafes before departure.",
                activities: [
                    "Leisure Morning",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Sharjah, a UNESCO Cultural Capital, is a city where tradition meets modernity. With its preserved heritage districts, world-class museums, and vibrant souks, Sharjah offers a deeply immersive cultural journey.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14484.451891726384!2d55.385605980495446!3d25.34625530939457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5f6a4a07369b7%3A0x6978e94f93ec0030!2sSharjah!5e0!3m2!1sen!2sae!4v1715802467890!5m2!1sen!2sae"
        },
        gallery: [
            images.tour6Gallery1,
            images.tour6Gallery2,
            images.tour6Gallery3,
            images.tour6Gallery4,
            images.tour6Gallery5,
            images.tour6Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour6Review1,
                name: "Fatima Al Zahrani",
                date: "October 12, 2025",
                rating: 5,
                content: "Sharjah’s rich culture was beautifully presented in this tour. The museums and art galleries were exceptional."
            },
            {
                id: 2,
                image: images.tour6Review2,
                name: "Omar Hassan",
                date: "October 13, 2025",
                rating: 4.9,
                content: "A perfect blend of heritage and leisure. Highly recommended for culture enthusiasts!"
            }
        ]
    },
    {
        id: 7,
        image: images.tour7,
        title: "Bali Escape",
        content: "Experience the beauty of Bali with its rice terraces, temples, and tropical beaches on this island retreat.",
        details: {
            location: "Indonesia",
            tourType: "Island Adventures",
            checkIn: "November 1, 2025",
            checkOut: "November 5, 2025",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "12 Years",
            maxAge: "65 Years",
            accommodation: "Beachfront Villas",
            transportation: "Included",
            bestSeason: "Spring and Summer",
            activity: "Beach & Island Tours, Adventure & Hiking"
        },
        overviews: [
            "Bali, an island paradise, offers a perfect blend of natural beauty and cultural richness. This tour invites you to unwind amidst scenic landscapes while immersing yourself in traditional Balinese culture."
        ],
        highlights: [
            "Visit to Ubud Monkey Forest",
            "Explore Tegallalang Rice Terraces",
            "Cultural Tour of Uluwatu Temple",
            "Beach Time at Seminyak",
            "Traditional Balinese Dance Performance"
        ],
        included: [
            "Professional Local Guide",
            "Entry Fees to Attractions",
            "3-Night Villa Accommodation",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Water Sports",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Ubud Exploration",
                description: "Arrive in Bali and transfer to Ubud for a guided walk through local markets and the iconic Monkey Forest.",
                activities: [
                    "Airport Pickup & Villa Check-in",
                    "Guided Tour of Ubud Markets",
                    "Visit to Monkey Forest Sanctuary"
                ]
            },
            {
                day: "Day 2: Temples & Rice Fields",
                description: "Explore Bali’s cultural landmarks including Tegallalang Rice Terraces and Uluwatu Temple, ending with a traditional dance show.",
                activities: [
                    "Morning Visit to Tegallalang Rice Terraces",
                    "Tour of Uluwatu Temple",
                    "Evening Kecak Dance Performance"
                ]
            },
            {
                day: "Day 3: Beach Leisure",
                description: "Relax and enjoy a day at Seminyak Beach, with optional water sports and spa treatments available.",
                activities: [
                    "Beach Leisure Time at Seminyak",
                    "Optional Surfing or Jet Skiing",
                    "Evening Spa Session (Optional)"
                ]
            },
            {
                day: "Day 4: Departure",
                description: "Morning free for shopping or visiting local cafes before airport transfer.",
                activities: [
                    "Leisure Morning Walks",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Bali is a tropical haven known for its volcanic mountains, lush rice paddies, beaches, and coral reefs. This tour offers a rejuvenating escape for travelers seeking both relaxation and cultural enrichment.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253464.7077368876!2d115.09195058585617!3d-8.409517844595364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd240f5e61c5277%3A0xf1f812de77e06ed4!2sBali!5e0!3m2!1sen!2sid!4v1715802467890!5m2!1sen!2sid"
        },
        gallery: [
            images.tour7Gallery1,
            images.tour7Gallery2,
            images.tour7Gallery3,
            images.tour7Gallery4,
            images.tour7Gallery5,
            images.tour7Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour7Review1,
                name: "Sophia Williams",
                date: "November 6, 2025",
                rating: 5,
                content: "Bali was a dream! Loved the cultural experiences and the villa stay was pure luxury."
            },
            {
                id: 2,
                image: images.tour7Review2,
                name: "Lucas Brown",
                date: "November 7, 2025",
                rating: 4.9,
                content: "Perfect mix of relaxation and exploration. The rice terraces and beach time were highlights for me."
            }
        ]
    },
    {
        id: 8,
        image: images.tour8,
        title: "Komodo Park",
        content: "Embark on an expedition to Komodo National Park, home to the Komodo dragons, islands, and coral reefs.",
        details: {
            location: "Indonesia",
            tourType: "Island Adventures",
            checkIn: "November 10, 2025",
            checkOut: "November 13, 2025",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "12 Years",
            maxAge: "65 Years",
            accommodation: "Eco-Lodges & Boat Stays",
            transportation: "Included",
            bestSeason: "April to October",
            activity: "Cultural Exploration, Adventure & Hiking"
        },
        overviews: [
            "Komodo National Park is a UNESCO World Heritage site, famous for its Komodo dragons and stunning marine biodiversity. This tour is ideal for adventure enthusiasts and nature lovers seeking unique encounters in a pristine environment."
        ],
        highlights: [
            "Guided Trek to Spot Komodo Dragons",
            "Snorkeling at Pink Beach",
            "Island Hopping to Padar & Rinca Islands",
            "Visit to Manta Point for Ray Sightings",
            "Sunset Cruise around Komodo Bay"
        ],
        included: [
            "Professional Wildlife Guide",
            "Park Entry Fees & Permits",
            "Boat Transfers & Island Hopping",
            "2-Night Accommodation",
            "Daily Meals"
        ],
        excluded: [
            "Personal Expenses",
            "Optional Diving Excursions",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Komodo Trek",
                description: "Arrive at Labuan Bajo and transfer by boat to Komodo Island for a guided trek to observe Komodo dragons in their natural habitat.",
                activities: [
                    "Airport Pickup & Boat Transfer",
                    "Guided Komodo Dragon Trek",
                    "Evening at Eco-Lodge"
                ]
            },
            {
                day: "Day 2: Island Hopping & Snorkeling",
                description: "Explore Padar Island for panoramic views, snorkel at Pink Beach, and visit Manta Point for a chance to see manta rays.",
                activities: [
                    "Morning Hike at Padar Island",
                    "Snorkeling at Pink Beach",
                    "Manta Ray Spotting at Manta Point",
                    "Sunset Boat Cruise"
                ]
            },
            {
                day: "Day 3: Rinca Island & Departure",
                description: "Visit Rinca Island for another chance to spot Komodo dragons, followed by a relaxing return cruise to Labuan Bajo for departure.",
                activities: [
                    "Morning Visit to Rinca Island",
                    "Leisure Cruise to Labuan Bajo",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Komodo National Park is an archipelago of rugged islands and rich marine ecosystems. From giant Komodo dragons to colorful coral reefs, the park offers a once-in-a-lifetime wildlife adventure.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253317.5948743465!2d119.32114994957274!3d-8.562602414854457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2db46bcfa43ec3b9%3A0x100f7e44f4f6000!2sKomodo%20National%20Park!5e0!3m2!1sen!2sid!4v1715802467890!5m2!1sen!2sid"
        },
        gallery: [
            images.tour8Gallery1,
            images.tour8Gallery2,
            images.tour8Gallery3,
            images.tour8Gallery4,
            images.tour8Gallery5,
            images.tour8Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour8Review1,
                name: "Ethan Walker",
                date: "November 14, 2025",
                rating: 5,
                content: "Seeing Komodo dragons up close was an unforgettable experience! The snorkeling spots were amazing too."
            },
            {
                id: 2,
                image: images.tour8Review2,
                name: "Mia Robinson",
                date: "November 15, 2025",
                rating: 4.9,
                content: "A thrilling adventure! Loved the boat cruise and the crystal-clear waters around Pink Beach."
            }
        ]
    },
    {
        id: 9,
        image: images.tour9,
        title: "Mount Bromo",
        content: "Witness the sunrise over Mount Bromo and explore the volcanic landscapes of East Java on this tour.",
        details: {
            location: "Indonesia",
            tourType: "Mountain Treks",
            checkIn: "November 20, 2025",
            checkOut: "November 25, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "12 Years",
            maxAge: "65 Years",
            accommodation: "Mountain Lodges & Homestays",
            transportation: "Included",
            bestSeason: "April to October",
            activity: "Adventure & Hiking"
        },
        overviews: [
            "Mount Bromo, one of Indonesia’s most iconic volcanoes, offers surreal landscapes and awe-inspiring sunrise views. This tour is perfect for adventure seekers and photography enthusiasts."
        ],
        highlights: [
            "Sunrise Trek to Mount Bromo Crater",
            "Explore Sea of Sand and Savanna Hills",
            "Visit Madakaripura Waterfall",
            "Scenic Jeep Adventure Rides",
            "Traditional Tenggerese Village Tour"
        ],
        included: [
            "Experienced Trekking Guide",
            "4-Night Accommodation",
            "Jeep Transfers within Bromo Area",
            "Daily Meals",
            "Entrance Fees to All Sites"
        ],
        excluded: [
            "Personal Trekking Gear",
            "Travel Insurance",
            "Personal Expenses",
            "Optional Horse Riding",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival in Surabaya & Transfer to Bromo",
                description: "Arrive at Surabaya Airport and transfer to a mountain lodge near Bromo. Evening at leisure.",
                activities: [
                    "Airport Pickup & Transfer",
                    "Hotel Check-in & Briefing",
                    "Free Evening at Lodge"
                ]
            },
            {
                day: "Day 2: Sunrise Trek & Crater Visit",
                description: "Early morning jeep ride to Penanjakan viewpoint for sunrise, followed by a trek to Bromo Crater.",
                activities: [
                    "Jeep Ride to Sunrise Viewpoint",
                    "Trek to Mount Bromo Crater Rim",
                    "Explore the Sea of Sand",
                    "Return to Lodge for Breakfast"
                ]
            },
            {
                day: "Day 3: Savanna Hills & Tenggerese Culture",
                description: "Explore the savanna hills and visit a traditional Tenggerese village to experience local culture.",
                activities: [
                    "Jeep Safari to Savanna Hills",
                    "Cultural Visit to Tenggerese Village",
                    "Evening at Leisure"
                ]
            },
            {
                day: "Day 4: Madakaripura Waterfall",
                description: "Visit the enchanting Madakaripura Waterfall, known for its towering cliffs and serene pools.",
                activities: [
                    "Morning Drive to Madakaripura",
                    "Trek to the Waterfall",
                    "Picnic Lunch by the Falls",
                    "Return to Lodge"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "After breakfast, transfer back to Surabaya Airport for departure.",
                activities: [
                    "Leisure Breakfast",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Mount Bromo, part of the Bromo Tengger Semeru National Park, is famed for its lunar-like landscapes, volcanic craters, and the legendary Sea of Sand. A must-visit for nature lovers and adventure photographers.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3954.5119582883796!2d112.95009911533172!3d-7.942493581539298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd630464aaa6b91%3A0xfda573d1767ecf52!2sMount%20Bromo!5e0!3m2!1sen!2sid!4v1715802467890!5m2!1sen!2sid"
        },
        gallery: [
            images.tour9Gallery1,
            images.tour9Gallery2,
            images.tour9Gallery3,
            images.tour9Gallery4,
            images.tour9Gallery5,
            images.tour9Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour9Review1,
                name: "Daniel Green",
                date: "November 26, 2025",
                rating: 5,
                content: "The sunrise at Bromo is something I’ll never forget! The tour was well-organized and the guides were excellent."
            },
            {
                id: 2,
                image: images.tour9Review2,
                name: "Hannah Lee",
                date: "November 27, 2025",
                rating: 4.9,
                content: "A must-do in Indonesia! The landscapes are surreal, and the cultural experience was a bonus."
            }
        ]
    },
    {
        id: 10,
        image: images.tour10,
        title: "Santorini Views",
        content: "Discover the beauty of Santorini with its villages, blue-domed churches, and Aegean sunsets on this island.",
        details: {
            location: "Greece",
            tourType: "Island Adventures",
            checkIn: "December 1, 2025",
            checkOut: "December 5, 2025",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Cliffside Boutique Hotels",
            transportation: "Included",
            bestSeason: "April to October",
            activity: "Sightseeing, Beach & Island Tours"
        },
        overviews: [
            "Santorini, a jewel of the Cyclades, offers breathtaking cliffside views, charming villages, and a rich blend of history and luxury. This tour is perfect for travelers seeking a relaxing yet culturally rich escape."
        ],
        highlights: [
            "Sunset Cruise along Caldera",
            "Explore Oia & Fira Villages",
            "Visit Ancient Akrotiri Ruins",
            "Wine Tasting at Local Vineyards",
            "Leisure Time on Red & Black Sand Beaches"
        ],
        included: [
            "Professional Local Guide",
            "3-Night Boutique Hotel Stay",
            "Daily Breakfast",
            "Sunset Caldera Cruise",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Spa Treatments",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Oia Village",
                description: "Arrive in Santorini and explore the picturesque streets of Oia with its iconic sunset views.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Guided Walk through Oia Village",
                    "Sunset Viewpoint Visit"
                ]
            },
            {
                day: "Day 2: Historical Exploration & Wine Tasting",
                description: "Discover the ancient ruins of Akrotiri and enjoy wine tasting sessions at renowned local wineries.",
                activities: [
                    "Visit to Akrotiri Archaeological Site",
                    "Afternoon Wine Tasting Tour",
                    "Leisure Evening in Fira Town"
                ]
            },
            {
                day: "Day 3: Caldera Cruise & Beach Leisure",
                description: "Embark on a sunset cruise along the caldera and relax on Santorini’s unique volcanic beaches.",
                activities: [
                    "Morning at Red & Black Sand Beaches",
                    "Sunset Caldera Sailing Cruise",
                    "Farewell Dinner (optional)"
                ]
            },
            {
                day: "Day 4: Departure",
                description: "Enjoy a relaxed morning with optional spa treatments before departure.",
                activities: [
                    "Optional Spa Treatments",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Santorini’s breathtaking cliffs, iconic blue domes, and crystal-clear waters create a postcard-perfect destination. From historical sites to luxurious retreats, Santorini promises an unforgettable island escape.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12776.050887546556!2d25.42891742193202!3d36.393156109683026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1499cd72f77f7c21%3A0x400bd2ce2b9a7f0!2sSantorini!5e0!3m2!1sen!2sgr!4v1715802467890!5m2!1sen!2sgr"
        },
        gallery: [
            images.tour10Gallery1,
            images.tour10Gallery2,
            images.tour10Gallery3,
            images.tour10Gallery4,
            images.tour10Gallery5,
            images.tour10Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour10Review1,
                name: "Isabella Moore",
                date: "December 6, 2025",
                rating: 5,
                content: "The sunsets in Santorini are out of this world! The wine tour was an unexpected delight. Loved every moment."
            },
            {
                id: 2,
                image: images.tour10Review2,
                name: "James Anderson",
                date: "December 7, 2025",
                rating: 4.9,
                content: "Perfect blend of relaxation and cultural experiences. The caldera cruise was the highlight for me!"
            }
        ]
    },
    {
        id: 11,
        image: images.tour11,
        title: "Mykonos Beaches",
        content: "Immerse yourself in the beach life of Mykonos, known for its sands, waters, and coastal atmosphere.",
        details: {
            location: "Greece",
            tourType: "Beach Escapes",
            checkIn: "December 10, 2025",
            checkOut: "December 13, 2025",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "12 Years",
            maxAge: "65 Years",
            accommodation: "Luxury Beach Resorts",
            transportation: "Included",
            bestSeason: "May to September",
            activity: "Sightseeing, Beach & Island Tours"
        },
        overviews: [
            "Mykonos, the cosmopolitan gem of the Aegean, offers a perfect blend of pristine beaches, charming Cycladic architecture, and world-renowned beach clubs. This tour is ideal for sun-seekers and party enthusiasts."
        ],
        highlights: [
            "Relaxation at Paradise & Super Paradise Beach",
            "Water Sports Adventure at Kalafatis Beach",
            "Evening Stroll in Mykonos Town",
            "Sunset Cocktails at Little Venice",
            "Optional Yacht Cruise Experience"
        ],
        included: [
            "3-Night Luxury Resort Stay",
            "Daily Breakfast",
            "Guided Beach Tours",
            "Airport Transfers",
            "Evening Mykonos Town Tour"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Yacht Cruise",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Beach Chill",
                description: "Arrive in Mykonos, check-in to your beach resort, and enjoy a relaxed afternoon at Paradise Beach.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Afternoon at Paradise Beach",
                    "Welcome Briefing"
                ]
            },
            {
                day: "Day 2: Water Sports & Town Exploration",
                description: "Adventure-filled day with water sports at Kalafatis Beach, followed by an evening stroll in Mykonos Town.",
                activities: [
                    "Morning Water Sports at Kalafatis Beach",
                    "Afternoon Leisure Time",
                    "Evening Mykonos Town Exploration",
                    "Sunset Cocktails at Little Venice"
                ]
            },
            {
                day: "Day 3: Optional Yacht Cruise & Departure",
                description: "Optional half-day yacht cruise or leisure morning before departure.",
                activities: [
                    "Optional Yacht Cruise to Nearby Islands",
                    "Relaxation at Resort",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Mykonos is famed for its golden beaches, chic boutiques, and lively beach clubs. Whether you’re looking to relax under the sun or dance till dawn, Mykonos delivers an unforgettable island escape.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12628.716883562935!2d25.323488311387735!3d37.44594306549587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a2e500244db6e1%3A0x400bd2ce2b9a7f0!2sMykonos!5e0!3m2!1sen!2sgr!4v1715802467890!5m2!1sen!2sgr"
        },
        gallery: [
            images.tour11Gallery1,
            images.tour11Gallery2,
            images.tour11Gallery3,
            images.tour11Gallery4,
            images.tour11Gallery5,
            images.tour11Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour11Review1,
                name: "Sophia White",
                date: "December 14, 2025",
                rating: 5,
                content: "Mykonos beaches are pure paradise! Loved the vibe, the sunsets, and the water sports activities."
            },
            {
                id: 2,
                image: images.tour11Review2,
                name: "Liam Brown",
                date: "December 15, 2025",
                rating: 4.8,
                content: "A perfect mix of relaxation and fun. The yacht cruise was a highlight of the trip!"
            }
        ]
    },
    {
        id: 12,
        image: images.tour12,
        title: "Delphi Ruins",
        content: "Step back in time and explore the mystical ruins of Delphi, once considered the center of the ancient Greek world.",
        details: {
            location: "Greece",
            tourType: "Cultural Heritage",
            checkIn: "December 18, 2025",
            checkOut: "December 22, 2025",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Traditional Stone Guesthouses",
            transportation: "Included",
            bestSeason: "March to November",
            activity: "Cultural Exploration"
        },
        overviews: [
            "Delphi, the ancient sanctuary of Apollo, offers a journey through Greece's mythical past. This tour immerses you in archaeological wonders, scenic mountain landscapes, and local cultural heritage."
        ],
        highlights: [
            "Guided Tour of Delphi Archaeological Site",
            "Visit to the Temple of Apollo",
            "Explore Delphi Archaeological Museum",
            "Scenic Walks on Mount Parnassus",
            "Traditional Greek Cultural Evenings"
        ],
        included: [
            "Professional Archaeological Guide",
            "4-Night Accommodation",
            "Entrance Fees to All Sites",
            "Daily Breakfast & Dinner",
            "Transportation to and from Athens"
        ],
        excluded: [
            "Lunch Meals",
            "Personal Expenses",
            "Optional Hiking Activities",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Village Walk",
                description: "Transfer from Athens to Delphi. Evening walk through Delphi village and introductory briefing.",
                activities: [
                    "Pickup from Athens",
                    "Check-in to Guesthouse",
                    "Evening Village Walk & Orientation"
                ]
            },
            {
                day: "Day 2: Temple of Apollo & Theater",
                description: "Begin with a guided tour of the Sanctuary of Apollo and the ancient theater.",
                activities: [
                    "Morning Visit to Temple of Apollo",
                    "Explore the Ancient Theater",
                    "Afternoon Leisure in Delphi Village"
                ]
            },
            {
                day: "Day 3: Museum & Castalian Spring",
                description: "Discover the treasures of Delphi Museum and visit the sacred Castalian Spring.",
                activities: [
                    "Morning Tour of Delphi Archaeological Museum",
                    "Visit Castalian Spring",
                    "Evening Cultural Dinner with Live Music"
                ]
            },
            {
                day: "Day 4: Mount Parnassus Walk",
                description: "Enjoy scenic walks on Mount Parnassus with optional hiking trails and panoramic views.",
                activities: [
                    "Morning Scenic Walks",
                    "Optional Guided Hiking Routes",
                    "Relaxed Afternoon in Delphi"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Leisure morning followed by transfer back to Athens.",
                activities: [
                    "Leisure Breakfast",
                    "Departure Transfer to Athens"
                ]
            }
        ],
        location: {
            description: "Nestled on the slopes of Mount Parnassus, Delphi offers a unique blend of ancient mythology, archaeological significance, and breathtaking landscapes. A must-visit for history buffs and culture enthusiasts.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3175.387650823762!2d22.4984890154365!3d38.483885579630725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135e3b3151c5d9a5%3A0x400bd2ce2b9a7f0!2sDelphi%2C%20Greece!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus"
        },
        gallery: [
            images.tour12Gallery1,
            images.tour12Gallery2,
            images.tour12Gallery3,
            images.tour12Gallery4,
            images.tour12Gallery5,
            images.tour12Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour12Review1,
                name: "Ethan Clark",
                date: "December 23, 2025",
                rating: 5,
                content: "Walking through Delphi felt like stepping into history. The guide's storytelling brought ancient myths to life."
            },
            {
                id: 2,
                image: images.tour12Review2,
                name: "Sophia Adams",
                date: "December 24, 2025",
                rating: 4.9,
                content: "An incredible archaeological journey. The views from Mount Parnassus were breathtaking."
            }
        ]
    },
    {
        id: 13,
        image: images.tour13,
        title: "Rome Wonders",
        content: "Discover the beauty of Rome, exploring ancient ruins, iconic landmarks, and Italian culture on this city tour.",
        details: {
            location: "Italy",
            tourType: "City Exploration",
            checkIn: "January 5, 2026",
            checkOut: "January 9, 2026",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Boutique City Hotels",
            transportation: "Included",
            bestSeason: "March to October",
            activity: "Sightseeing"
        },
        overviews: [
            "Rome, the Eternal City, offers a journey through centuries of history, art, and culture. From the grandeur of the Colosseum to the elegance of the Vatican, this tour captures the essence of Italy's capital."
        ],
        highlights: [
            "Guided Tour of Colosseum & Roman Forum",
            "Visit to Vatican City & St. Peter's Basilica",
            "Explore Trevi Fountain & Spanish Steps",
            "Authentic Italian Pasta-Making Workshop",
            "Evening Walking Tour of Piazza Navona"
        ],
        included: [
            "Professional Local Guide",
            "3-Night Accommodation",
            "Daily Breakfast",
            "Entrance Fees to Major Attractions",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Personal Expenses",
            "Optional Culinary Experiences",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Evening Stroll",
                description: "Arrive in Rome, settle into your hotel, and enjoy a relaxing evening walk to Trevi Fountain and Spanish Steps.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Stroll to Trevi Fountain & Spanish Steps",
                    "Welcome Briefing"
                ]
            },
            {
                day: "Day 2: Colosseum & Roman Forum",
                description: "Dive into ancient history with a guided tour of the Colosseum and Roman Forum, followed by leisure time in the city center.",
                activities: [
                    "Morning Guided Tour of Colosseum",
                    "Walk through Roman Forum & Palatine Hill",
                    "Afternoon Free Exploration"
                ]
            },
            {
                day: "Day 3: Vatican & Culinary Experience",
                description: "Explore the wonders of Vatican City in the morning and join an authentic Italian pasta-making workshop in the afternoon.",
                activities: [
                    "Visit St. Peter's Basilica & Vatican Museums",
                    "Sistine Chapel Tour",
                    "Afternoon Pasta-Making Workshop"
                ]
            },
            {
                day: "Day 4: Piazza Navona & Departure",
                description: "Enjoy a final morning exploring Piazza Navona and Campo de' Fiori before departure.",
                activities: [
                    "Morning Walking Tour of Piazza Navona",
                    "Leisure Shopping & Farewell",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Rome’s cobblestone streets, majestic ruins, and timeless piazzas offer an unforgettable experience for history lovers and culture enthusiasts alike.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2994.0142325020086!2d12.49223081567436!3d41.89021077922156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61a3e7d0a7d3%3A0xf9c2b52e23b4b9ab!2sColosseum!5e0!3m2!1sen!2sit!4v1715802467890!5m2!1sen!2sit"
        },
        gallery: [
            images.tour13Gallery1,
            images.tour13Gallery2,
            images.tour13Gallery3,
            images.tour13Gallery4,
            images.tour13Gallery5,
            images.tour13Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour13Review1,
                name: "Olivia Rossi",
                date: "January 10, 2026",
                rating: 5,
                content: "The best way to experience Rome! The guide was amazing, and I loved the pasta-making class."
            },
            {
                id: 2,
                image: images.tour13Review2,
                name: "Daniel Carter",
                date: "January 11, 2026",
                rating: 4.9,
                content: "From the Colosseum to Vatican City, every moment was memorable. Well organized and informative."
            }
        ]
    },
    {
        id: 14,
        image: images.tour14,
        title: "Florence Art",
        content: "Discover the of the Renaissance as you explore Florence's art, architecture, and cultural heritage.",
        details: {
            location: "Italy",
            tourType: "Cultural Heritage",
            checkIn: "January 12, 2026",
            checkOut: "January 15, 2026",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "12 Years",
            maxAge: "70 Years",
            accommodation: "Heritage Boutique Hotels",
            transportation: "Included",
            bestSeason: "April to October",
            activity: "Sightseeing"
        },
        overviews: [
            "Florence, the birthplace of the Renaissance, is home to world-class art galleries, magnificent cathedrals, and iconic architectural marvels. This tour immerses you in the city's artistic legacy and cultural treasures."
        ],
        highlights: [
            "Guided Tour of Uffizi Gallery",
            "Visit to Florence Cathedral & Giotto’s Campanile",
            "Walk through Ponte Vecchio & Piazza della Signoria",
            "Explore Accademia Gallery (Michelangelo’s David)",
            "Evening Cultural Walk with Local Artisans"
        ],
        included: [
            "3-Night Accommodation",
            "Professional Art Historian Guide",
            "Entrance Fees to Museums",
            "Daily Breakfast",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Workshops (Painting/Ceramics)",
            "Personal Expenses",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Orientation Walk",
                description: "Arrive in Florence and enjoy a guided walk through the historic center, visiting Piazza della Signoria and Ponte Vecchio.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Orientation Walk in Historic Center",
                    "Evening Welcome Briefing"
                ]
            },
            {
                day: "Day 2: Uffizi & Cathedral",
                description: "Dive into Renaissance art with a guided tour of the Uffizi Gallery and Florence Cathedral, including Giotto's Bell Tower.",
                activities: [
                    "Morning Visit to Uffizi Gallery",
                    "Florence Cathedral & Giotto’s Campanile",
                    "Leisure Afternoon for Local Exploration"
                ]
            },
            {
                day: "Day 3: Accademia & Artisan Walk",
                description: "Visit Accademia Gallery to see Michelangelo’s David, followed by an evening artisan walk exploring local workshops.",
                activities: [
                    "Morning Tour of Accademia Gallery",
                    "Afternoon Free Time",
                    "Evening Artisan Walk & Farewell"
                ]
            }
        ],
        location: {
            description: "Florence’s artistic charm and historical significance make it a must-visit destination for art lovers and culture enthusiasts. Walk through its cobbled streets and immerse yourself in the beauty of Renaissance masterpieces.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.3589626489396!2d11.255708115831668!3d43.769560879116624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a56aa45eab99b%3A0xb81c8364eb2db19e!2sFlorence!5e0!3m2!1sen!2sit!4v1715802467890!5m2!1sen!2sit"
        },
        gallery: [
            images.tour14Gallery1,
            images.tour14Gallery2,
            images.tour14Gallery3,
            images.tour14Gallery4,
            images.tour14Gallery5,
            images.tour14Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour14Review1,
                name: "Emma Wilson",
                date: "January 16, 2026",
                rating: 5,
                content: "An art lover’s dream! The Uffizi and Accademia tours were outstanding, and the artisan walk was a unique touch."
            },
            {
                id: 2,
                image: images.tour14Review2,
                name: "Lucas Bennett",
                date: "January 17, 2026",
                rating: 4.8,
                content: "Florence is breathtaking. The guide’s insights into Renaissance art made the trip unforgettable."
            }
        ]
    },
    {
        id: 15,
        image: images.tour15,
        title: "Venice Canals",
        content: "Experience the charm of Venice through its enchanting canals, iconic landmarks, and romantic atmosphere.",
        details: {
            location: "Italy",
            tourType: "City Exploration",
            checkIn: "January 18, 2026",
            checkOut: "January 22, 2026",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Luxury Waterfront Hotels",
            transportation: "Included",
            bestSeason: "April to October",
            activity: "Sightseeing, Water Activities"
        },
        overviews: [
            "Venice, a city of winding canals and timeless beauty, invites you to explore its historic palaces, vibrant squares, and serene waterways. This tour offers a romantic and cultural journey through Italy’s floating city."
        ],
        highlights: [
            "Gondola Ride through Grand Canal",
            "Visit to St. Mark's Basilica & Doge's Palace",
            "Walk through Rialto Market & Bridge",
            "Murano Glassmaking Demonstration",
            "Evening Walking Tour of Piazza San Marco"
        ],
        included: [
            "Professional Local Guide",
            "4-Night Accommodation",
            "Daily Breakfast",
            "Gondola Ride Experience",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Lagoon Island Tours",
            "Personal Expenses",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Grand Canal Tour",
                description: "Arrive in Venice and enjoy a scenic boat ride through the Grand Canal, followed by a guided evening walk in San Marco district.",
                activities: [
                    "Water Taxi Transfer & Hotel Check-in",
                    "Grand Canal Boat Tour",
                    "Evening Stroll in San Marco"
                ]
            },
            {
                day: "Day 2: St. Mark's & Doge's Palace",
                description: "Visit St. Mark's Basilica and explore the historical Doge's Palace with a guided tour.",
                activities: [
                    "Morning Guided Tour of St. Mark's Basilica",
                    "Doge's Palace & Bridge of Sighs Visit",
                    "Afternoon Leisure Time"
                ]
            },
            {
                day: "Day 3: Rialto & Gondola Ride",
                description: "Explore the bustling Rialto Market and enjoy a traditional gondola ride through Venice’s canals.",
                activities: [
                    "Visit Rialto Market & Bridge",
                    "Gondola Ride through Hidden Canals",
                    "Optional Venetian Mask Workshop"
                ]
            },
            {
                day: "Day 4: Murano & Free Exploration",
                description: "Take a morning visit to Murano Island for a glassmaking demonstration. Spend the rest of the day exploring Venice at your own pace.",
                activities: [
                    "Morning Murano Island Visit",
                    "Glassmaking Demonstration",
                    "Free Afternoon for Shopping & Cafes"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Leisure morning before departure transfer.",
                activities: [
                    "Breakfast & Check-out",
                    "Water Taxi Transfer to Airport"
                ]
            }
        ],
        location: {
            description: "Venice’s labyrinth of canals, historic landmarks, and romantic gondola rides make it a city like no other. This tour allows you to experience Venice’s charm from both water and land.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2889.896539261547!2d12.31551531582953!3d45.44084777910025!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477eb1d5a0fc5d5f%3A0x429ba685e63c9ed!2sVenice!5e0!3m2!1sen!2sit!4v1715802467890!5m2!1sen!2sit"
        },
        gallery: [
            images.tour15Gallery1,
            images.tour15Gallery2,
            images.tour15Gallery3,
            images.tour15Gallery4,
            images.tour15Gallery5,
            images.tour15Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour15Review1,
                name: "Sophia Lombardi",
                date: "January 23, 2026",
                rating: 5,
                content: "A magical experience! The gondola ride was the highlight of my trip. Venice is pure romance."
            },
            {
                id: 2,
                image: images.tour15Review2,
                name: "James Evans",
                date: "January 24, 2026",
                rating: 4.8,
                content: "Loved the history and charm of Venice. The tour was well-paced and the Murano glass demo was fascinating."
            }
        ]
    },
    {
        id: 16,
        image: images.tour16,
        title: "Bangkok City",
        content: "Dive into the vibrant culture, bustling markets, and majestic temples of Bangkok on this exciting city exploration tour.",
        details: {
            location: "Thailand",
            tourType: "City Exploration",
            checkIn: "February 5, 2026",
            checkOut: "February 9, 2026",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "City Boutique Hotels",
            transportation: "Included",
            bestSeason: "November to March",
            activity: "Sightseeing, Water Activities"
        },
        overviews: [
            "Bangkok, a city of contrasts, offers a rich blend of traditional culture and modern vibrancy. Explore ornate temples, lively street markets, and savor authentic Thai cuisine on this immersive city tour."
        ],
        highlights: [
            "Grand Palace & Emerald Buddha Visit",
            "Wat Arun & Wat Pho Temple Tours",
            "Floating Market Excursion",
            "Traditional Thai Cultural Show",
            "Evening Street Food Tour"
        ],
        included: [
            "Professional Local Guide",
            "3-Night Accommodation",
            "Daily Breakfast",
            "Entrance Fees to Attractions",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Personal Shopping Expenses",
            "Optional Cooking Classes",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Orientation Walk",
                description: "Arrive in Bangkok, check into your hotel, and enjoy a guided evening walk around the bustling city center.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Orientation Walk",
                    "Welcome Briefing with Guide"
                ]
            },
            {
                day: "Day 2: Temples & Grand Palace",
                description: "Visit Bangkok’s iconic temples including Wat Pho and Wat Arun, followed by a tour of the Grand Palace.",
                activities: [
                    "Morning Visit to Wat Pho & Wat Arun",
                    "Guided Tour of the Grand Palace",
                    "Afternoon Leisure Time"
                ]
            },
            {
                day: "Day 3: Floating Market & Street Food",
                description: "Experience the famous floating markets and indulge in a guided street food tour in the evening.",
                activities: [
                    "Morning Floating Market Excursion",
                    "Cultural Show or Museum Visit (optional)",
                    "Evening Street Food Tour"
                ]
            },
            {
                day: "Day 4: Local Markets & Departure",
                description: "Explore Chatuchak Weekend Market or local artisan markets for souvenirs before departure.",
                activities: [
                    "Morning Market Visit",
                    "Leisure Time for Shopping",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Bangkok’s charm lies in its blend of rich traditions and dynamic urban life. From golden temples to vibrant street markets, this city promises an unforgettable cultural journey.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.865047748025!2d100.49269081569098!3d13.7563309903535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e2991732eaf0ef%3A0x6ec5ef0f2dffb73b!2sBangkok!5e0!3m2!1sen!2sth!4v1715802467890!5m2!1sen!2sth"
        },
        gallery: [
            images.tour16Gallery1,
            images.tour16Gallery2,
            images.tour16Gallery3,
            images.tour16Gallery4,
            images.tour16Gallery5,
            images.tour16Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour16Review1,
                name: "Isabella Nguyen",
                date: "February 10, 2026",
                rating: 5,
                content: "An incredible introduction to Bangkok’s culture and food scene. The floating market was a highlight!"
            },
            {
                id: 2,
                image: images.tour16Review2,
                name: "Oliver Thompson",
                date: "February 11, 2026",
                rating: 4.9,
                content: "Loved every bit of this tour. The temples are stunning, and the street food tour was delicious and fun."
            }
        ]
    },
    {
        id: 17,
        image: images.tour17,
        title: "Chiang Mai",
        content: "Experience the heart of Northern Thailand with treks, temples, and local experiences in Chiang Mai.",
        details: {
            location: "Thailand",
            tourType: "Nature Retreats",
            checkIn: "March 5, 2026",
            checkOut: "March 8, 2026",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Traditional Thai Resorts",
            transportation: "Included",
            bestSeason: "November to March",
            activity: "Cultural Exploration"
        },
        overviews: [
            "Chiang Mai offers a perfect blend of cultural heritage and natural beauty. Explore serene temples, vibrant local markets, and lush mountain landscapes on this carefully curated tour."
        ],
        highlights: [
            "Visit to Doi Suthep Temple",
            "Trekking in Doi Inthanon National Park",
            "Local Thai Cooking Class",
            "Handicraft Village Tour",
            "Evening Chiang Mai Night Bazaar"
        ],
        included: [
            "Professional Local Guide",
            "2-Night Accommodation",
            "Daily Breakfast & Lunch",
            "Entrance Fees to Attractions",
            "Airport Transfers"
        ],
        excluded: [
            "Dinner",
            "Optional Elephant Sanctuary Visit",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Doi Suthep Visit",
                description: "Arrive in Chiang Mai and visit the iconic Wat Phra That Doi Suthep temple for panoramic views of the city.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Visit to Doi Suthep Temple",
                    "Evening Leisure Time"
                ]
            },
            {
                day: "Day 2: National Park Trek & Handicrafts",
                description: "Spend the day trekking through Doi Inthanon National Park and visit a local handicraft village.",
                activities: [
                    "Morning Trek in Doi Inthanon",
                    "Visit to Karen Hill Tribe Village",
                    "Handicraft Demonstrations",
                    "Evening Visit to Chiang Mai Night Bazaar"
                ]
            },
            {
                day: "Day 3: Cooking Class & Departure",
                description: "Participate in a Thai cooking class before your departure.",
                activities: [
                    "Morning Thai Cooking Class",
                    "Leisure Time for Last-Minute Shopping",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Chiang Mai’s rich culture, combined with its scenic landscapes and warm hospitality, makes it an unforgettable destination for travelers seeking both adventure and tradition.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.262878312399!2d98.98468331562152!3d18.78834358721008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da3a5f5ef0cf35%3A0xe6a3fc5b03eaf2f6!2sChiang%20Mai%2C%20Thailand!5e0!3m2!1sen!2sth!4v1715802467890!5m2!1sen!2sth"
        },
        gallery: [
            images.tour17Gallery1,
            images.tour17Gallery2,
            images.tour17Gallery3,
            images.tour17Gallery4,
            images.tour17Gallery5,
            images.tour17Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour17Review1,
                name: "Ava Carter",
                date: "March 9, 2026",
                rating: 5,
                content: "Loved every bit of this tour. The temple views, the national park trek, and the cooking class were all amazing experiences!"
            },
            {
                id: 2,
                image: images.tour17Review2,
                name: "Liam Garcia",
                date: "March 10, 2026",
                rating: 4.9,
                content: "Chiang Mai is beautiful and this tour was very well organized. The local markets and the night bazaar were so vibrant!"
            }
        ]
    },
    {
        id: 18,
        image: images.tour18,
        title: "Phuket Beaches",
        content: "Discover the tropical paradise of Phuket with its stunning beaches, vibrant nightlife, and exciting island-hopping adventures.",
        details: {
            location: "Thailand",
            tourType: "Beach Escapes",
            checkIn: "April 5, 2026",
            checkOut: "April 10, 2026",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "8 Years",
            maxAge: "65 Years",
            accommodation: "Seaside Resorts",
            transportation: "Included",
            bestSeason: "November to April",
            activity: "Beach & Island Tours"
        },
        overviews: [
            "Phuket’s crystal-clear waters, white sandy beaches, and lively atmosphere make it a must-visit destination. This tour combines relaxation, adventure, and cultural experiences, offering the best of Thailand’s largest island."
        ],
        highlights: [
            "Patong Beach Relaxation",
            "Phi Phi Islands Day Trip",
            "Big Buddha & Wat Chalong Visit",
            "Evening Phuket Night Market",
            "Phuket Fantasea Cultural Show"
        ],
        included: [
            "Professional Tour Guide",
            "4-Night Resort Accommodation",
            "Daily Breakfast",
            "Island Hopping Boat Trip",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Personal Water Sports Activities",
            "Travel Insurance",
            "Personal Expenses",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Beach Leisure",
                description: "Arrive in Phuket and spend your first day relaxing on the beautiful Patong Beach.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Relaxation at Patong Beach",
                    "Evening Leisure Walk"
                ]
            },
            {
                day: "Day 2: Phi Phi Islands Adventure",
                description: "Enjoy a full-day island hopping tour to Phi Phi Islands with snorkeling and beach time.",
                activities: [
                    "Morning Departure to Phi Phi Islands",
                    "Snorkeling & Beach Time",
                    "Lunch on the Beach",
                    "Return to Phuket by Evening"
                ]
            },
            {
                day: "Day 3: Cultural Sites & Market",
                description: "Explore Phuket’s cultural landmarks and enjoy shopping at the night market.",
                activities: [
                    "Visit Big Buddha & Wat Chalong",
                    "Afternoon Leisure Time",
                    "Evening Visit to Phuket Night Market"
                ]
            },
            {
                day: "Day 4: Free Day or Optional Tours",
                description: "Spend the day at leisure or opt for additional activities like elephant sanctuary visit or scuba diving.",
                activities: [
                    "Free Day for Relaxation or Optional Tours",
                    "Evening Phuket Fantasea Cultural Show"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Leisure morning before departure.",
                activities: [
                    "Breakfast & Check-out",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Phuket’s beaches are famous for their beauty and energy. From tranquil coves to vibrant beach clubs, this island tour offers the perfect mix of relaxation and adventure.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12694.338857084327!2d98.29220121471384!3d7.880447182287901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30503bde7c9d1e3f%3A0x40223bc2c9c9bb0!2sPhuket!5e0!3m2!1sen!2sth!4v1715802467890!5m2!1sen!2sth"
        },
        gallery: [
            images.tour18Gallery1,
            images.tour18Gallery2,
            images.tour18Gallery3,
            images.tour18Gallery4,
            images.tour18Gallery5,
            images.tour18Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour18Review1,
                name: "Emma Walker",
                date: "April 11, 2026",
                rating: 5,
                content: "The Phi Phi Islands trip was breathtaking! Loved the beach vibes and the vibrant night market."
            },
            {
                id: 2,
                image: images.tour18Review2,
                name: "Daniel Hughes",
                date: "April 12, 2026",
                rating: 4.8,
                content: "Perfect balance of relaxation and adventure. The cultural show was a beautiful experience!"
            }
        ]
    },
    {
        id: 19,
        image: images.tour19,
        title: "Cairo Wonders",
        content: "Uncover the mysteries of Cairo with visits to the Pyramids of Giza, Egyptian Museum, and local bazaars.",
        details: {
            location: "Egypt",
            tourType: "City Exploration",
            checkIn: "May 5, 2026",
            checkOut: "May 9, 2026",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "City Heritage Hotels",
            transportation: "Included",
            bestSeason: "October to April",
            activity: "Cultural Exploration"
        },
        overviews: [
            "Step back in time and explore the grandeur of ancient Egypt in Cairo. This tour takes you to iconic sites like the Pyramids of Giza and the Egyptian Museum, while also immersing you in the vibrant local culture."
        ],
        highlights: [
            "Guided Tour of Pyramids of Giza & Sphinx",
            "Visit to Egyptian Museum",
            "Stroll through Khan El Khalili Bazaar",
            "Nile River Dinner Cruise",
            "Sound & Light Show at the Pyramids"
        ],
        included: [
            "Professional Egyptologist Guide",
            "3-Night Hotel Stay",
            "Daily Breakfast",
            "All Entrance Fees",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch and Dinner",
            "Optional Camel Ride",
            "Personal Expenses",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Museum Visit",
                description: "Arrive in Cairo and visit the world-famous Egyptian Museum to explore ancient artifacts.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Visit to Egyptian Museum",
                    "Welcome Briefing"
                ]
            },
            {
                day: "Day 2: Pyramids & Sphinx",
                description: "Spend the day exploring the Pyramids of Giza and the Sphinx with a guided historical tour.",
                activities: [
                    "Guided Tour of Giza Pyramids",
                    "Visit to Sphinx & Valley Temple",
                    "Optional Camel Ride Experience"
                ]
            },
            {
                day: "Day 3: Bazaars & Nile Cruise",
                description: "Explore Cairo’s bustling bazaars and enjoy a relaxing dinner cruise on the Nile River.",
                activities: [
                    "Shopping at Khan El Khalili Bazaar",
                    "Leisure Afternoon",
                    "Nile River Dinner Cruise"
                ]
            },
            {
                day: "Day 4: Departure",
                description: "Free time for personal exploration or relaxation before departure.",
                activities: [
                    "Leisure Morning",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Cairo, the heart of Egypt, is a city where ancient wonders meet vibrant modern life. From its awe-inspiring monuments to its colorful markets, this city promises a rich cultural experience.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.040346241845!2d31.235711815445845!3d30.04441928187654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583f7f8b2dffb1%3A0xe7b5f8ff0dba2ffb!2sCairo%2C%20Egypt!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus"
        },
        gallery: [
            images.tour19Gallery1,
            images.tour19Gallery2,
            images.tour19Gallery3,
            images.tour19Gallery4,
            images.tour19Gallery5,
            images.tour19Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour19Review1,
                name: "Sophia Ahmed",
                date: "May 10, 2026",
                rating: 5,
                content: "A breathtaking journey through history! The pyramids are truly a wonder, and the Nile cruise was the perfect ending."
            },
            {
                id: 2,
                image: images.tour19Review2,
                name: "Ethan Roberts",
                date: "May 11, 2026",
                rating: 4.9,
                content: "The tour was fantastic, with a knowledgeable guide who made history come alive. Highly recommend this experience!"
            }
        ]
    },
    {
        id: 20,
        image: images.tour20,
        title: "Aswan Nile",
        content: "Sail through the serene Nile waters in Aswan while exploring ancient temples, vibrant souks, and authentic Nubian villages.",
        details: {
            location: "Egypt",
            tourType: "Cultural Heritage",
            checkIn: "May 12, 2026",
            checkOut: "May 15, 2026",
            duration: "3 Days",
            person: "1 Person",
            price: 900,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "Nile River Cruises",
            transportation: "Included",
            bestSeason: "October to April",
            activity: "Cultural Exploration, Water Activities"
        },
        overviews: [
            "Discover Aswan’s peaceful ambiance with a tour that blends ancient history and local culture. Visit iconic temples, sail on traditional felucca boats, and interact with Nubian communities along the Nile."
        ],
        highlights: [
            "Felucca Sail on the Nile",
            "Philae Temple Guided Tour",
            "Visit to Unfinished Obelisk",
            "Nubian Village Cultural Experience",
            "Aswan Souk Exploration"
        ],
        included: [
            "Professional Egyptologist Guide",
            "2-Night Accommodation (Cruise or Hotel)",
            "Daily Breakfast & Lunch",
            "All Entry Tickets",
            "Airport or Train Station Transfers"
        ],
        excluded: [
            "Dinner",
            "Optional Abu Simbel Excursion",
            "Personal Expenses",
            "Travel Insurance",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Philae Temple",
                description: "Arrive in Aswan and visit the beautiful Philae Temple, followed by a scenic felucca sail on the Nile.",
                activities: [
                    "Airport/Station Pickup & Hotel Check-in",
                    "Guided Tour of Philae Temple",
                    "Evening Felucca Ride on the Nile"
                ]
            },
            {
                day: "Day 2: Nubian Culture & Obelisk",
                description: "Explore the Unfinished Obelisk and engage in a cultural visit to a traditional Nubian village.",
                activities: [
                    "Morning Visit to Unfinished Obelisk",
                    "Cultural Tour of Nubian Village",
                    "Leisure Afternoon at Aswan Souk"
                ]
            },
            {
                day: "Day 3: Departure",
                description: "Free time for last-minute shopping or optional Abu Simbel tour before departure.",
                activities: [
                    "Optional Morning Excursion to Abu Simbel",
                    "Airport/Station Transfer"
                ]
            }
        ],
        location: {
            description: "Aswan’s charm lies in its tranquil river scenery, rich heritage, and warm Nubian culture. This tour offers a relaxing yet insightful journey through Southern Egypt’s treasures.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3460.4540373477115!2d32.89982931544315!3d24.088938384394456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x144b1a24f5b7c7ef%3A0x3f08a07e0b5c36c1!2sAswan%2C%20Egypt!5e0!3m2!1sen!2seg!4v1715802467890!5m2!1sen!2seg"
        },
        gallery: [
            images.tour20Gallery1,
            images.tour20Gallery2,
            images.tour20Gallery3,
            images.tour20Gallery4,
            images.tour20Gallery5,
            images.tour20Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour20Review1,
                name: "Isabella Turner",
                date: "May 16, 2026",
                rating: 5,
                content: "A peaceful and culturally rich experience! Sailing on the felucca at sunset was a highlight."
            },
            {
                id: 2,
                image: images.tour20Review2,
                name: "Lucas White",
                date: "May 17, 2026",
                rating: 4.8,
                content: "Loved the Nubian village visit and the Philae Temple tour. Everything was well organized and smooth."
            }
        ]
    },
    {
        id: 21,
        image: images.tour21,
        title: "Siwa Oasis",
        content: "Escape to the remote beauty of Siwa Oasis, where golden dunes, salt lakes, and ancient ruins create a desert paradise.",
        details: {
            location: "Egypt",
            tourType: "Desert Expeditions",
            checkIn: "October 10, 2026",
            checkOut: "October 15, 2026",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "12 Years",
            maxAge: "65 Years",
            accommodation: "Eco-Lodges & Desert Camps",
            transportation: "Included",
            bestSeason: "October to March",
            activity: "Cultural Exploration, Desert Safari, Adventure & Hiking"
        },
        overviews: [
            "Venture into the secluded Siwa Oasis, known for its lush date palms, shimmering salt lakes, and centuries-old Berber culture. This eco-tour blends adventure, wellness, and heritage in Egypt’s hidden gem."
        ],
        highlights: [
            "4x4 Desert Safari & Sandboarding",
            "Temple of the Oracle Visit",
            "Swim in Cleopatra's Spring",
            "Explore Salt Lakes & Fossil Mountain",
            "Traditional Siwan Handicraft Workshops"
        ],
        included: [
            "Professional Local Guide",
            "4-Night Accommodation (Eco-Lodge & Camp)",
            "Daily Breakfast & Dinner",
            "All Excursions & Entry Fees",
            "Roundtrip Transportation from Cairo"
        ],
        excluded: [
            "Lunch",
            "Personal Expenses",
            "Travel Insurance",
            "Optional Spa Treatments",
            "Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Orientation",
                description: "Depart from Cairo to Siwa Oasis by private transfer. After check-in, enjoy a relaxed evening with a welcome briefing.",
                activities: [
                    "Cairo to Siwa Transfer",
                    "Eco-Lodge Check-in",
                    "Evening Welcome Dinner & Orientation"
                ]
            },
            {
                day: "Day 2: Historical Wonders",
                description: "Visit the Temple of the Oracle and Mountain of the Dead, followed by a swim in Cleopatra's Spring.",
                activities: [
                    "Morning Visit to Temple of the Oracle",
                    "Exploration of Mountain of the Dead",
                    "Afternoon Swim in Cleopatra's Spring",
                    "Leisure Time at the Lodge"
                ]
            },
            {
                day: "Day 3: Salt Lakes & Fossil Mountain",
                description: "Discover Siwa’s breathtaking salt lakes and Fossil Mountain, with opportunities for photography and relaxation.",
                activities: [
                    "Morning Salt Lake Swim",
                    "Guided Walk at Fossil Mountain",
                    "Siwan Handicrafts Workshop",
                    "Evening Campfire Gathering"
                ]
            },
            {
                day: "Day 4: Desert Safari Adventure",
                description: "Embark on an exhilarating 4x4 desert safari, sandboarding, and sunset views over the Great Sand Sea.",
                activities: [
                    "Morning Desert Safari & Sandboarding",
                    "Lunch Picnic in the Dunes",
                    "Sunset Over the Great Sand Sea",
                    "Overnight Desert Camp Experience"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Return journey to Cairo after breakfast.",
                activities: [
                    "Breakfast at Camp",
                    "Return Transfer to Cairo"
                ]
            }
        ],
        location: {
            description: "Siwa Oasis is a desert haven where natural beauty and ancient history converge. From salt pools to oracle temples, Siwa offers a serene escape into Egypt’s wilderness.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13776.449859504107!2d25.5452022!3d29.203183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458c13d80e8f0f5%3A0x72020bffdb833d09!2sSiwa%20Oasis%2C%20Siwa%2C%20Matrouh%20Governorate%2C%20Egypt!5e0!3m2!1sen!2seg!4v1715802467890!5m2!1sen!2seg"
        },
        gallery: [
            images.tour21Gallery1,
            images.tour21Gallery2,
            images.tour21Gallery3,
            images.tour21Gallery4,
            images.tour21Gallery5,
            images.tour21Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour21Review1,
                name: "Amelia Green",
                date: "October 16, 2026",
                rating: 5,
                content: "Siwa is an untouched paradise! Loved the salt lakes and the desert safari—an unforgettable eco-adventure."
            },
            {
                id: 2,
                image: images.tour21Review2,
                name: "Benjamin Carter",
                date: "October 17, 2026",
                rating: 4.9,
                content: "The eco-lodges were charming and the guide was so knowledgeable about Siwa’s history. Highly recommend!"
            }
        ]
    },
    {
        id: 22,
        image: images.tour22,
        title: "Mexico City",
        content: "Dive into the vibrant heart of Mexico with a city tour showcasing rich history, colorful culture, and world-renowned cuisine.",
        details: {
            location: "Mexico",
            tourType: "Cultural Heritage",
            checkIn: "November 5, 2026",
            checkOut: "November 9, 2026",
            duration: "4 Days",
            person: "1 Person",
            price: 800,
            minAge: "10 Years",
            maxAge: "70 Years",
            accommodation: "City Boutique Hotels",
            transportation: "Included",
            bestSeason: "October to April",
            activity: "Sightseeing"
        },
        overviews: [
            "Discover Mexico City's dynamic blend of ancient Aztec ruins, colonial architecture, and a thriving modern art scene. This tour offers an immersive experience into the soul of Mexico's capital."
        ],
        highlights: [
            "Guided Tour of Zócalo & Metropolitan Cathedral",
            "Visit to Templo Mayor Ruins",
            "Explore Frida Kahlo’s Casa Azul",
            "Culinary Walk through Local Markets",
            "Boat Ride in Xochimilco Canals"
        ],
        included: [
            "Expert Local Guide",
            "3-Night Boutique Hotel Stay",
            "Daily Breakfast & One Dinner",
            "All Entry Fees & Tickets",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch (except for culinary tour day)",
            "Personal Expenses",
            "Travel Insurance",
            "Optional Nightlife Tour",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Historic Center",
                description: "Arrive in Mexico City, check-in, and enjoy an evening guided tour of the Zócalo and historic center.",
                activities: [
                    "Airport Pickup & Hotel Check-in",
                    "Evening Guided Tour of Historic Center",
                    "Welcome Briefing"
                ]
            },
            {
                day: "Day 2: Museums & Culture",
                description: "Visit the National Palace, Templo Mayor ruins, and spend the afternoon at Frida Kahlo’s Casa Azul in Coyoacán.",
                activities: [
                    "Morning Visit to National Palace & Murals",
                    "Explore Templo Mayor Archaeological Site",
                    "Frida Kahlo Museum (Casa Azul) Tour",
                    "Free Evening for Optional Activities"
                ]
            },
            {
                day: "Day 3: Markets & Xochimilco",
                description: "Experience a culinary tour in bustling local markets, followed by a colorful boat ride through Xochimilco canals.",
                activities: [
                    "Morning Culinary Market Walk",
                    "Lunch Tasting of Street Foods",
                    "Xochimilco Trajinera Boat Ride",
                    "Group Dinner at Traditional Mexican Restaurant"
                ]
            },
            {
                day: "Day 4: Departure",
                description: "Free morning for last-minute shopping or visiting Chapultepec Park before departure.",
                activities: [
                    "Leisure Morning at Chapultepec Park or Museums",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Mexico City is a vibrant metropolis where pre-Hispanic ruins sit alongside colonial cathedrals and modern skyscrapers. This tour immerses you in its rich heritage, art, and culinary delights.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12093.97218543547!2d-99.14561880778188!3d19.432607764177264!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff33287e11ab%3A0x37e7c2e22a2e0d59!2sMexico%20City%2C%20CDMX%2C%20Mexico!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus"
        },
        gallery: [
            images.tour22Gallery1,
            images.tour22Gallery2,
            images.tour22Gallery3,
            images.tour22Gallery4,
            images.tour22Gallery5,
            images.tour22Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour22Review1,
                name: "Sofia Martinez",
                date: "November 10, 2026",
                rating: 5,
                content: "An amazing cultural journey! The market tour and Xochimilco boat ride were unforgettable highlights."
            },
            {
                id: 2,
                image: images.tour22Review2,
                name: "Daniel Hernandez",
                date: "November 11, 2026",
                rating: 4.8,
                content: "Perfectly organized city tour. Loved the blend of history, art, and food experiences. Highly recommend it!"
            }
        ]
    },
    {
        id: 23,
        image: images.tour23,
        title: "Chichen Itza",
        content: "Step into the world of Mayan civilization with a tour of Chichen Itza, one of the New Seven Wonders of the World.",
        details: {
            location: "Mexico",
            tourType: "Cultural Heritage",
            checkIn: "November 12, 2026",
            checkOut: "November 13, 2026",
            duration: "2 Days",
            person: "1 Person",
            price: 900,
            minAge: "8 Years",
            maxAge: "70 Years",
            accommodation: "Nearby Boutique Hotels",
            transportation: "Included",
            bestSeason: "November to April",
            activity: "Cultural Exploration"
        },
        overviews: [
            "Explore the legendary city of Chichen Itza with its iconic El Castillo Pyramid, the Great Ball Court, and the Temple of Warriors. This in-depth tour provides a fascinating insight into Mayan culture, architecture, and astronomy."
        ],
        highlights: [
            "Guided Tour of El Castillo (Kukulkan Pyramid)",
            "Visit to the Great Ball Court",
            "Temple of the Warriors & Group of a Thousand Columns",
            "Sacred Cenote Exploration",
            "Light & Sound Show Experience (optional)"
        ],
        included: [
            "Professional Archaeological Guide",
            "Entry Tickets to Chichen Itza",
            "1-Night Boutique Hotel Stay",
            "Breakfast & Lunch",
            "Roundtrip Transportation from Cancun"
        ],
        excluded: [
            "Dinner",
            "Optional Light & Sound Show Ticket",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Chichen Itza Tour",
                description: "Depart from Cancun and head to Chichen Itza. Begin your guided tour exploring the pyramid, temples, and cenotes, with plenty of opportunities for photography.",
                activities: [
                    "Hotel Pickup in Cancun",
                    "Guided Tour of Chichen Itza",
                    "Visit to Sacred Cenote",
                    "Check-in at Boutique Hotel",
                    "Optional Light & Sound Show in the Evening"
                ]
            },
            {
                day: "Day 2: Cultural Walk & Return",
                description: "Enjoy a morning cultural walk through nearby artisan markets, followed by return transfer to Cancun.",
                activities: [
                    "Morning Market Walk",
                    "Free Time for Souvenirs",
                    "Return Transfer to Cancun"
                ]
            }
        ],
        location: {
            description: "Chichen Itza, a UNESCO World Heritage Site, is an awe-inspiring archaeological site showcasing the brilliance of Mayan engineering and cosmology. Discover its iconic structures and ancient legends with an expert guide.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.415419441938!2d-88.56858828491736!3d20.684284686195497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5138d0aa0eab2d%3A0x8b1a5f38fc392e7a!2sChichen%20Itza%2C%20Yucatan%2C%20Mexico!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus"
        },
        gallery: [
            images.tour23Gallery1,
            images.tour23Gallery2,
            images.tour23Gallery3,
            images.tour23Gallery4,
            images.tour23Gallery5,
            images.tour23Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour23Review1,
                name: "Lucas Rivera",
                date: "November 14, 2026",
                rating: 5,
                content: "Walking through Chichen Itza was like stepping back in time. The guide's stories made the ruins come alive!"
            },
            {
                id: 2,
                image: images.tour23Review2,
                name: "Isabella Gomez",
                date: "November 15, 2026",
                rating: 4.9,
                content: "The architecture and history are mind-blowing. Loved the optional light show at night—magical experience."
            }
        ]
    },
    {
        id: 24,
        image: images.tour24,
        title: "Cancun Escape",
        content: "Relax with a beachside escape in Cancun, known for its turquoise waters, beaches, and nightlife.",
        details: {
            location: "Mexico",
            tourType: "Beach Escapes",
            checkIn: "November 16, 2026",
            checkOut: "November 21, 2026",
            duration: "5 Days",
            person: "1 Person",
            price: 1000,
            minAge: "5 Years",
            maxAge: "70 Years",
            accommodation: "Luxury Beach Resorts",
            transportation: "Included",
            bestSeason: "December to April",
            activity: "Sightseeing, Beach & Island Tours"
        },
        overviews: [
            "Experience the perfect blend of relaxation and adventure with a Cancun escape. Spend your days lounging on pristine beaches, diving into vibrant coral reefs, and exploring the energetic nightlife that defines this tropical paradise."
        ],
        highlights: [
            "Stay at a 5-Star Beachfront Resort",
            "Snorkeling in the Great Mesoamerican Reef",
            "Sunset Catamaran Cruise",
            "Day Trip to Isla Mujeres",
            "Evenings at Cancun's Nightlife Spots"
        ],
        included: [
            "5-Night Resort Accommodation",
            "Daily Breakfast & 2 Dinners",
            "Snorkeling Equipment & Guide",
            "Sunset Catamaran Tour",
            "Airport Transfers"
        ],
        excluded: [
            "Lunch Meals",
            "Optional Spa Treatments",
            "Personal Expenses",
            "Travel Insurance",
            "Tips & Gratuities"
        ],
        tourPlan: [
            {
                day: "Day 1: Arrival & Beach Time",
                description: "Arrive in Cancun, check into your beachfront resort, and spend the afternoon unwinding by the sea.",
                activities: [
                    "Airport Pickup & Resort Check-in",
                    "Welcome Cocktail & Orientation",
                    "Afternoon Relaxation on the Beach"
                ]
            },
            {
                day: "Day 2: Snorkeling Adventure",
                description: "Head out for a guided snorkeling tour in the Great Mesoamerican Reef, discovering colorful marine life.",
                activities: [
                    "Morning Snorkeling Tour",
                    "Afternoon Free Time at Resort",
                    "Optional Evening Entertainment"
                ]
            },
            {
                day: "Day 3: Isla Mujeres Excursion",
                description: "Take a catamaran cruise to Isla Mujeres, enjoy beach activities, and visit the famous Playa Norte.",
                activities: [
                    "Catamaran Cruise to Isla Mujeres",
                    "Beachside Lunch on the Island",
                    "Free Time for Exploration"
                ]
            },
            {
                day: "Day 4: Leisure & Nightlife",
                description: "Relax by the pool or indulge in spa treatments during the day, followed by an evening exploring Cancun’s famous nightlife.",
                activities: [
                    "Optional Spa & Wellness Treatments",
                    "Afternoon Poolside Relaxation",
                    "Evening Visit to Nightclubs & Bars"
                ]
            },
            {
                day: "Day 5: Departure",
                description: "Enjoy a leisurely breakfast and a final morning beach walk before your departure.",
                activities: [
                    "Morning Leisure Walk",
                    "Airport Transfer"
                ]
            }
        ],
        location: {
            description: "Cancun, a tropical haven on Mexico's Caribbean coast, offers a vibrant mix of stunning beaches, lively nightlife, and thrilling water adventures. Perfect for travelers seeking relaxation with a touch of excitement.",
            map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d119365.0895435608!2d-86.89305965993403!3d21.161907813252385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4c2b512bbef83f%3A0x36f890ec5824691b!2sCancun%2C%20Quintana%20Roo%2C%20Mexico!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus"
        },
        gallery: [
            images.tour24Gallery1,
            images.tour24Gallery2,
            images.tour24Gallery3,
            images.tour24Gallery4,
            images.tour24Gallery5,
            images.tour24Gallery6
        ],
        comments: [
            {
                id: 1,
                image: images.tour24Review1,
                name: "Natalie Rivera",
                date: "November 22, 2026",
                rating: 5,
                content: "A dreamy beach escape! The snorkeling trip and Isla Mujeres were my favorites. Highly recommend!"
            },
            {
                id: 2,
                image: images.tour24Review2,
                name: "Carlos Martinez",
                date: "November 23, 2026",
                rating: 4.9,
                content: "Perfect vacation mix of relaxation and adventure. The resort was amazing and the nightlife was vibrant!"
            }
        ]
    }

];

export default tours;